import { Box, Grid, Link, Typography } from "@mui/material";

const SpecialAnnouncement = () => {
  return (
    <Grid
      container
      alignItems="center"
      sx={{ borderRadius: 2, boxShadow: 3, p: 3, mb: 3, mt: -3 }}
      item
      xs={12}
    >
      <Grid item xs={12} container alignItems="center">
        <Typography component="div">
          <Box sx={{ fontSize: 15 }}>
            <strong>🏆 TikTok Contest is Now Live!</strong>
            <br />
          </Box>
          Win a free month of Virtual Assistant or the top prize of $250 and a
          paid partnership opportunity to create TikTok content for Bento.{" "}
          <Link
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLSeLfyHp8bsUbEuyOGo2d0-wvv0G9nnOZBoXErK8J7Ua8LHWBg/viewform"
          >
            More details here.
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SpecialAnnouncement;
